

// 获取资源类型
export const getFileType = (urls) => {
    // console.log('getFileType', urls)
    if (!urls || urls.length == 0) {
        return ''
    }
    let typs = []
    for (let i = 0; i < urls.length; i++) {
        let url = urls[i].url || urls[i].file_name
        if (
            typs.indexOf('图片') == -1 &&
            (url.indexOf('png') !== -1 ||
                url.indexOf('PNG') !== -1 ||
                url.indexOf('jpg') !== -1 ||
                url.indexOf('JPG') !== -1 ||
                url.indexOf('jpeg') !== -1 ||
                url.indexOf('JPEG') !== -1)
        ) {
            typs.push('图片')
        }
        if (
            typs.indexOf('PPT') == -1 &&
            (url.indexOf('PPT') !== -1 || url.indexOf('ppt') !== -1 || url.indexOf('PPTX') !== -1 || url.indexOf('pptx') !== -1)
        ) {
            typs.push('PPT')
        }
        if (
            typs.indexOf('PDF') == -1 &&
            (url.indexOf('PDF') !== -1 || url.indexOf('pdf') !== -1)
        ) {
            typs.push('PDF')
        }
        if (
            typs.indexOf('word') == -1 &&
            (url.indexOf('docx') !== -1 || url.indexOf('doc') !== -1)
        ) {
            typs.push('word')
        }
        if (
            typs.indexOf('视频') == -1 &&
            (url.indexOf('MP4') !== -1 || url.indexOf('mp4') !== -1)
        ) {
            typs.push('视频')
        }
        if (
            typs.indexOf('音频') == -1 &&
            (url.indexOf('MP3') !== -1 || url.indexOf('mp3') !== -1)
        ) {
            typs.push('音频')
        }
    }
    return typs.join('/')
}